import { render } from "./SetToolbar.vue?vue&type=template&id=cfdbd4e2"
import script from "./SetToolbar.vue?vue&type=script&lang=js"
export * from "./SetToolbar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__